import React, { useState } from "react"
import { IconButton, Menu, MenuItem } from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { COLORS } from "../utils"

export const MoreMenu = ({ menus, color = COLORS.BLACK800, menuProps = {}, iconButtonProps = {} }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelectMenu = (menu) => {
    if (menu) {
      menu.onClick()
    }
    handleClose()
  }

  if (!menus || !menus.length || !Array.isArray(menus)) return null

  return (
    <>
      <IconButton
        id="more-menu-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        size="large"
        {...iconButtonProps}
      >
        <MoreVertIcon sx={{ color: color || COLORS.LABEL_GREY, fontSize: iconButtonProps.isSmall ? "24px" : "30px" }} />
      </IconButton>
      <Menu
        id="more-menu"
        open={Boolean(open)}
        anchorEl={anchorEl}
        onClose={handleClose}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
        MenuListProps={{
          "aria-labelledby": "more-menu-button",
        }}
        {...menuProps}
      >
        {menus.map((menu, index) => (
          <span key={index} title={menu.title} style={{ display: "block" }}>
            <MenuItem
              disabled={menu.disabled}
              onClick={() => handleSelectMenu(menu)}
              sx={menu.disabled ? { pointerEvents: "none" } : undefined}
            >
              {menu.label}
            </MenuItem>
          </span>
        ))}
      </Menu>
    </>
  )
}

export default MoreMenu